(function () {
  "use strict";

  var STORAGE_KEY = "nuvra_viewed_products";
  var MAX_VIEWS = 24;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function write(views) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(views.slice(0, MAX_VIEWS)));
  }

  function record(entry) {
    if (!entry || (!entry.handle && !entry.id)) return;

    var views = read().filter(function (v) {
      if (entry.handle && v.handle === entry.handle) return false;
      if (entry.id && String(v.id) === String(entry.id)) return false;
      return true;
    });

    views.unshift({
      id: entry.id ? String(entry.id) : "",
      handle: entry.handle || "",
      viewedAt: Date.now(),
    });

    write(views);
    document.dispatchEvent(new CustomEvent("nuvra:views-updated"));
  }

  function getViews() {
    return read();
  }

  function handleFromLink(link) {
    if (!link) return null;
    var href = link.getAttribute("href") || "";
    var match = href.match(/\/products\/([^/?#]+)/);
    if (!match) return null;

    var item =
      link.closest("[data-product-handle]") ||
      link.closest("[data-product-id]") ||
      link.closest(".nuvra-recommended__item") ||
      link.closest(".nuvra-scroll-item");

    return {
      handle: decodeURIComponent(match[1]),
      id: item && item.dataset.productId ? item.dataset.productId : "",
    };
  }

  window.NuvraViews = {
    record: record,
    getViews: getViews,
  };

  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var info = handleFromLink(link);
    if (info) record(info);
  });

  function bootFromProductPage() {
    var boot = document.getElementById("nuvra-page-product");
    if (!boot) return;
    record({
      id: boot.dataset.productId || "",
      handle: boot.dataset.productHandle || "",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootFromProductPage);
  } else {
    bootFromProductPage();
  }
})();
